import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { MasterDB } from 'src/app/DAO/MasterDB';

@Component({
  selector: 'app-sincronizar-revisiones',
  templateUrl: './sincronizar-revisiones.component.html',
  styleUrls: ['./sincronizar-revisiones.component.css']
})
export class SincronizarRevisionesComponent implements OnInit {
  url: string;
  subMenus: object[];
  title: string;
  revisiones: any;

  constructor(private http: HttpClient, private router: Router) {
    this.title = 'Sincronizar revisiones';
  }

  syncClick(idRevision) {
    this.syncRevision(idRevision);
  }



  ngOnInit() {
    this.loadSubMenu();
    this.getRevisiones().then(result => {
      this.revisiones = result;

      Utilerias.showLoader(false);
    });
  }

  loadSubMenu() {
    var items = [
      {
        active: true,
        child: false,
        label: 'SincronizarRevisiones',
        class: 'submenu__item submenu--active d-flex align-items-center'
      },
      {
        active: false,
        child: true,
        label: 'MisRevisiones',
        router: 'MisRevisiones',
        class: 'submenu__item d-flex align-items-center'
      }];
    this.subMenus = items;
  }

  getRevisiones = function () {
    return Utilerias.httpRequest(this.http, 'GetRevisiones', 'get');
  }

  syncRevision = function (idRevision) {
    MasterDB.getLocalRevision(idRevision)
      .then(result => {
        return Utilerias.httpRequest(this.http, 'SincronizarRevision', 'post', result)
      })
      .then(result => {
        let data = result;
        return MasterDB.postSyncData(data)
      })
      .then(() => {
        Utilerias.showLoader(false);
        this.router.navigate(['MisRevisiones']);
      })
      .catch(error => {
        Utilerias.showLoader(false);
        alert(environment.errorMessage);
      });
  }
}
